import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TableFilter from '../TableFilter'
import RubricaSearchTable from './RubricaSearchTable'
import RubricaTipoSoggettoSelect from './RubricaTipoSoggettoSelect'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import FiltriMultiDropdown from '../FiltriMultiDropdown'

class RubricaSearch extends Component {
    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {
                columnName: 'soggetto',
                direction: 'A',
                data: [{field: 's.cognome', direction: 'A'}, {field: 's.nome', direction: 'A'}]},
            filterInfo: {
                conditions: '',
                multiFilter: [],
            },
            _loading: false,
            error: null,
            cfg: client.getConfigurazione(),
            filterLetter: {tipo:'s', lettera:'All'},
            filterTipo: {isProspect:false, isCliente:false, isFornitore:false, isTp:false},
            showItem: null,
        };
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeFilterSoggetto = this.onChangeFilterSoggetto.bind(this)
        this.onChangeFilterDipartimento = this.onChangeFilterDipartimento.bind(this)
        this.onChangeFilterOrganizzazione = this.onChangeFilterOrganizzazione.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onChangeLetter = this.onChangeLetter.bind(this)
        this.onChangeTipoSoggetto = this.onChangeTipoSoggetto.bind(this)
        this.onSelectSoggetto = this.onSelectSoggetto.bind(this)
        this.loadData = this.loadData.bind(this)
        this.onChangeMultiFiltri = this.onChangeMultiFiltri.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
    }

    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.soggetto !== undefined && this.state.filterInfo.soggetto !== ''){
            msg += 'KW Soggetto: ' + this.state.filterInfo.soggetto + ' ';
        }
        if (this.state.filterInfo.dipartimento !== undefined && this.state.filterInfo.dipartimento !== ''){
            msg += 'KW Dipartimento: ' + this.state.filterInfo.dipartimento + ' ';
        }
        if (this.state.filterInfo.organizzazione !== undefined && this.state.filterInfo.organizzazione !== ''){
            msg += 'KW Organizzazione: ' + this.state.filterInfo.organizzazione + ' ';
        }
        if (this.state.filterTipo.isProspect){
            msg += ' Prospect: SI';
        }
        if (this.state.filterTipo.isCliente){
            msg += ' Clienti: SI';
        }
        if (this.state.filterTipo.isFornitore){
            msg += ' Fornitore: SI';
        }
        if (this.state.filterTipo.isTp){
            msg += ' Terze parti: SI';
        }
        let condAggiuntive = client.getCondizioniAggiuntive(this.state.filterInfo.conditions, this.state.filterInfo.multiFilter)
        if (condAggiuntive){
            msg += ' ' + condAggiuntive;
        }
        return  msg.trim();
    }

    componentWillMount() {
    }

    componentWillUnmount() {
    }

    componentDidMount() {

    }

    onChangePage(newpage) {

        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter)
    }

    onChangeColumnOrder(columnName, direction, data) {
        let newOrderInfo = {
            columnName: columnName,
            direction: direction,
            data: data
        }
        this.loadData(1, newOrderInfo, this.state.filterInfo, this.state.filterLetter)
    }

    onChangeFilter(data){
        this.loadData(1, this.state.orderInfo, data, this.state.filterLetter)
    }
    onChangeFilterSoggetto(data){
        let fi = this.state.filterInfo;
        fi.soggetto = data.keyword;
        this.loadData(1, this.state.orderInfo, fi, this.state.filterLetter)
    }
    onChangeFilterDipartimento(data){
        let fi = this.state.filterInfo;
        fi.dipartimento = data.keyword;
        this.loadData(1, this.state.orderInfo, fi, this.state.filterLetter)
    }
    onChangeFilterOrganizzazione(data){
        let fi = this.state.filterInfo;
        fi.organizzazione = data.keyword;
        this.loadData(1, this.state.orderInfo, fi, this.state.filterLetter)
    }

    onChangeTipoSoggetto(isProspect, isCliente, isFornitore, isTp){
        let newFilterInfo = {
            isProspect,
            isCliente,
            isFornitore,
            isTp
        };
        this.loadData(1, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter, newFilterInfo);
    }

    onChangeLetter(tipo, letter){
        let newOrderInfo = {
            field: tipo === 's' ? 's.cognome' : tipo+".nome",
            direction: 'A'
        };
        let newFilterLetter = {
            tipo:tipo,
            lettera:letter
        };
        this.loadData(1, newOrderInfo, this.state.filterInfo, newFilterLetter);
    }

    loadData(page, orderInfo, filterInfo, filterLetter, filterTipo = null) {
        if (filterTipo === null){
            filterTipo = this.state.filterTipo;
        }
        this.setState({_loading: true});
        client.loadRubricaList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo,
            filterLetter,
            filterTipo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        filterLetter: filterLetter,
                        filterTipo: filterTipo,
                        _loading: false,
                        error: null,
                        showItem: null,
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onChangeMultiFiltri(ev, {name, value}){
        let filter = this.state.filterInfo;
        filter.multiFilter = value;
        this.loadData(1, this.state.orderInfo, filter, this.state.filterLetter)
    }

    onLoadingMultiFiltri(){}

    onSelectSoggetto(soggetto){
        if(this.props.onSelectSoggetto){
            this.props.onSelectSoggetto(soggetto);
        }
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui huge loader"></div>
                </div>
            );
        }

        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui two column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Soggetti soddisfano i filtri specificati
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">
                        </div>
                    </div>
                </div>
            </h3>
            <div className="ui attached segment">
                <div className="ui four column stackable grid">
                    <div className="column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.soggetto}
                            placeholder="Nome e cognome del soggetto..."
                            onChangeFilter={this.onChangeFilterSoggetto} />
                    </div>
                    <div className="column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.dipartimento}
                            placeholder="Nome del dipartimento..."
                            onChangeFilter={this.onChangeFilterDipartimento} />
                    </div>
                    <div className="column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.organizzazione}
                            placeholder="Nome dell'organizzazione..."
                            onChangeFilter={this.onChangeFilterOrganizzazione} />
                    </div>
                    <div className="column">
                        <RubricaTipoSoggettoSelect
                            isProspect={this.state.filterTipo.isProspect}
                            isCliente={this.state.filterTipo.isCliente}
                            isFornitore={this.state.filterTipo.isFornitore}
                            isTp={this.state.filterTipo.isTp}
                            onChange={this.onChangeTipoSoggetto}
                        />
                    </div>
                    <div className="eight wide column">
                        <FiltriMultiDropdown tipo="RUB" name='filtri'
                                             value={this.state.filterInfo.multiFilter}
                                             onChange={this.onChangeMultiFiltri}
                                             onLoading={this.onLoadingMultiFiltri}
                        />
                    </div>
                </div>

            {/*<RubricaLetterSelect*/}
                {/*letter={this.state.filterLetter.lettera}*/}
                {/*tipo={this.state.filterLetter.tipo}*/}
                {/*onChange={this.onChangeLetter}*/}
            {/*/>*/}
            </div>

            <RubricaSearchTable
                items={this.state.items}
                count={this.state.total}
                page={this.state.page}
                rowperpage={this.rowperpage}
                tableOrderingField={this.state.orderInfo.columnName}
                tableOrderingDirection={this.state.orderInfo.direction}
                filterDescription={this.getFilterDescription()}
                onChangePage={this.onChangePage}
                onChangeOrder={this.onChangeColumnOrder}
                onSelectSoggetto={this.onSelectSoggetto}
            />
            {loader}
        </div>)
    }
}

RubricaSearch.PropTypes = {
    onSelectSoggetto: PropTypes.func
}

RubricaSearch.contextTypes = {
    router: PropTypes.object,
}


export default RubricaSearch;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaSearch.js
 **/